import { render } from "./right.vue?vue&type=template&id=357a1caf"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"

import "./right.vue?vue&type=style&index=0&id=357a1caf&lang=postcss"
script.render = render

export default script